// Simple i18n cache for CRAFT CARE.
// Strings are fetched from the API endpoint getI18nStrings?lang=xx.
// Switching languages stores the choice in localStorage and re-fetches.

import { reactive } from "vue";
import { executeJson, hms } from "@/api";

const FALLBACK_LANG = "en";

const state = reactive({
  lang: localStorage.getItem("craftcare_lang") || FALLBACK_LANG,
  strings: {},
  loaded: false,
  available: [
    { code: "en",  label: "English"   },
    { code: "sw",  label: "Kiswahili" },
    { code: "maa", label: "Maa"       }
  ]
});

async function load(lang) {
  try {
    const r = await executeJson({ function: "getI18nStrings", lang }, hms);
    if (r.data && r.data.success) {
      state.strings = r.data.data.strings || {};
      state.loaded = true;
    }
  } catch (e) {
    state.strings = {};
  }
}

async function setLang(lang) {
  state.lang = lang;
  localStorage.setItem("craftcare_lang", lang);
  await load(lang);
}

function t(key, fallback) {
  if (state.strings[key]) return state.strings[key];
  return fallback || key;
}

// auto-load on import
load(state.lang);

export function useI18n() {
  return { state, t, setLang };
}

export { state as i18nState, t, setLang };
